import i18n from 'i18next';

import { SessionService } from '@ac/library-utils/dist/services';

export const setupUILanguage = () => {
  const language = SessionService.getLanguage() || 'en';
  i18n.changeLanguage(language);
};



// WEBPACK FOOTER //
// ./src/utils/setupUILanguage.ts